import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import createLocation from 'utils/createLocation';
import queryparse from 'tricks/string/queryparse';
import { SwitchField } from 'components/Fields';
import { jsx as _jsx } from "react/jsx-runtime";
function DueDateFilter() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var navigate = useNavigate();
  var location = useLocation();
  var queryParams = queryparse(location.search);
  var onlyWithDueDate = queryParams.onlyWithDueDate;
  var onlyWithDueDateFilterOn = onlyWithDueDate === 'true';
  function handleChange() {
    navigate(createLocation(location.pathname, _objectSpread(_objectSpread({}, queryParams), {}, {
      onlyWithDueDate: onlyWithDueDateFilterOn ? undefined : true,
      page: undefined
    })), {
      replace: true
    });
  }
  return /*#__PURE__*/_jsx(SwitchField, {
    id: "due-date-filter",
    title: t('property_due_date_colon'),
    value: onlyWithDueDateFilterOn,
    boldTitle: false,
    readout: function readout() {
      return null;
    },
    onChange: handleChange
  });
}
export default DueDateFilter;